import { render } from "./AvailableBranches.vue?vue&type=template&id=cb22f39c"
import script from "./AvailableBranches.vue?vue&type=script&lang=js"
export * from "./AvailableBranches.vue?vue&type=script&lang=js"

import "./AvailableBranches.vue?vue&type=style&index=0&id=cb22f39c&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__